import React from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader, Tooltip } from "reactstrap";
import { Icon } from "react-icons-kit";
import { getServerEndpoint } from "../../utils/serverEndpoint";
import { redo } from "react-icons-kit/icomoon/redo";
import { undo } from "react-icons-kit/icomoon/undo";
import { circleLeft } from "react-icons-kit/icomoon/circleLeft";
import { circleRight } from "react-icons-kit/icomoon/circleRight";
import { languageService } from "../../Language/language.service";
import { ModalStyles } from "./styles";

import { CommonModalStyle } from "style/basic/commonControls";
import { themeService } from "theme/service/activeTheme.service";
import { basicColors, retroColors, electricColors } from "style/basic/basicColors";
import { MyButton } from "components/Common/Forms/formsMiscItems";
import { fetchStaticResource } from "../../utils/utils";

const ROTATION_TOOLTIP = [
  {
    title: "REDO",
    icon: redo,
    rotate: "right",
    placement: "top",
    tooltip: {
      show: false,
      text: `${languageService("Rotate clockwise")}`,
    },
  },
  {
    title: "UNDO",
    icon: undo,
    placement: "right",
    rotate: "left",
    tooltip: {
      show: false,
      text: `${languageService("Rotate anti-clockwise")}`,
    },
  },
];

class ImageSlider extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      images: [],
      selectedImageIndex: 0,
      tooltip: null,
      rotateIndex: 0,
      imageToDisplay: null,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.imgSlider && this.props.imgSlider !== prevProps.imgSlider) {
      this.setState(
        {
          images: this.props.images,
          selectedImageIndex: this.props.initialIndex,
        },
        this.updateImageToDisplay,
      );
    }
  }

  updateImageToDisplay = async () => {
    const { selectedImageIndex, images } = this.state;
    const { imageDirectory } = this.props;

    if (images.length > 0) {
      const imgName = images[selectedImageIndex].imgName || images[selectedImageIndex];
      const imgPath = `${getServerEndpoint()}${imageDirectory}/${imgName}`;
      const imageToDisplay = await fetchStaticResource(imgPath);

      this.setState({ imageToDisplay });
    }
  };

  handleImageTransition = (newIndex) => {
    if (this.state.images[newIndex]) {
      this.setState({ selectedImageIndex: newIndex }, this.updateImageToDisplay);
    }
  };

  handelRotate = (direction) => {
    this.setState((prevState) => ({
      rotateIndex: prevState.rotateIndex + (direction === "right" ? 90 : -90),
    }));
  };

  toggleTooltip = (tooltipTitle) => {
    this.setState((prevState) => ({
      tooltip: prevState.tooltip === tooltipTitle ? null : tooltipTitle,
    }));
  };

  render() {
    const { selectedImageIndex, images, rotateIndex, imageToDisplay, tooltip } = this.state;
    const { imgSlider, handleToggle } = this.props;

    return (
      <Modal isOpen={imgSlider} toggle={handleToggle} style={{ height: "auto" }}>
        <ModalHeader style={{ ...ModalStyles.modalTitleStyle, ...themeService(CommonModalStyle.header) }}>
          {images[selectedImageIndex] && images[selectedImageIndex].displayTitle
            ? `${languageService("Gallery View")} (${images[selectedImageIndex].displayTitle})`
            : languageService("Gallery View")}
        </ModalHeader>

        <div style={{ position: "absolute", top: "17px", right: "10px" }}>
          {ROTATION_TOOLTIP.map(({ title, icon, rotate, placement, tooltip }) => (
            <React.Fragment key={title}>
              <button
                onClick={() => this.handelRotate(rotate)}
                id={title}
                style={{
                  marginRight: "10px",
                  background: "var(--nine)",
                  color: "black",
                  padding: "5px",
                  borderRadius: "5px",
                  height: "28px",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                <Icon icon={icon} />
              </button>
              <Tooltip placement={placement} isOpen={tooltip === title} target={title} toggle={() => this.toggleTooltip(title)}>
                {tooltip.text}
              </Tooltip>
            </React.Fragment>
          ))}
        </div>

        <ModalBody style={{ ...themeService(CommonModalStyle.body), textAlign: "center", overflow: "hidden", maxHeight: "80vh" }}>
          <div
            className="scrollbar"
            style={{
              padding: "10px",
              transitionDuration: "0.4s",
              background: "#f7f7f7",
              border: "1px solid #e0e0e0",
              display: "inline-block",
              transform: `rotate(${rotateIndex}deg)`,
              maxHeight: "70vh",
              overflow: "auto",
            }}
          >
            {/* {imageToDisplay && ( */}
            <img
              src={imageToDisplay}
              style={{
                display: "block",
                margin: "auto",
                border: "1px solid #e3e9ef",
                width: "100%",
              }}
              alt={"image"}
            />
            {/* )} */}
          </div>
        </ModalBody>

        <ModalFooter style={{ ...ModalStyles.footerButtonsContainer, ...themeService(CommonModalStyle.footer), textAlign: "right" }}>
          <div style={{ textAlign: "center", width: "100%" }}>
            <Icon
              icon={circleLeft}
              size={30}
              className="circle-left"
              onClick={() => this.handleImageTransition(selectedImageIndex - 1)}
              style={{
                cursor: images[selectedImageIndex - 1] ? "pointer" : "not-allowed",
                color: images[selectedImageIndex - 1] ? "var(--first)" : "grey",
              }}
            />
            <Icon
              icon={circleRight}
              size={30}
              className="circle-right"
              onClick={() => this.handleImageTransition(selectedImageIndex + 1)}
              style={{
                cursor: images[selectedImageIndex + 1] ? "pointer" : "not-allowed",
                color: images[selectedImageIndex + 1] ? "var(--first)" : "grey",
              }}
            />
          </div>
          <MyButton onClick={handleToggle}>{languageService("Close")}</MyButton>
        </ModalFooter>
      </Modal>
    );
  }
}

export default ImageSlider;



// WEBPACK FOOTER //
// ./src/components/Common/ImageSlider.jsx